<div>
  <strong>Comments</strong>
  <div class="mt-1" *ngIf="rejection.Note">
    {{ rejection.Note }}
  </div>
</div>
